const state = {
  newTask: false,
  clickExport: false,
}

const getters = {}

const mutations = {
  setTaskStatus(state, payload) {
    state.newTask = payload
  },
  getClickExport(state, payload) {
    state.newTask = payload
  },
}
const actions = {
  setTaskStatus({ commit }) {
    commit('setTaskStatus')
  },
  getClickExport({ commit }) {
    commit('getClickExport')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
